/* eslint-disable */
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { Button, Modal, CardContent } from '@mui/material';
import MainCard from 'components/MainCard';
import SpeakerNotesIcon from '@mui/icons-material/SpeakerNotes';
import PdfViewer from "components/pdf/PdfViewer"
import { fileAccepts } from 'data/data';
import { getDownloadByFid } from "components/axios/fileManagerAxios";

const PdfLayer = ({file}) => {
    const { t } = useTranslation();

    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
        downFromFile();
    }
    const handleClose = () => setOpen(false);

    const [accept, setAccept] = useState(null);
    const [fileUrl, setFileUrl] = useState(null);
    
    useEffect(()=>{
        downFromFile();
    },[file]);

    const downFromFile = () => {
        if (file) {
            const extension = file.originFile.substring(file.originFile.lastIndexOf("."));
            setAccept(fileAccepts.filter(acc => acc.extension.indexOf(extension) !== -1)[0]);
            setFileUrl(process.env.REACT_APP_API_URL+"/api/download/"+file.id);
        }
    }

    if (file && accept && accept.code === 'P') {
        return (
            <>
            <SpeakerNotesIcon onClick={handleOpen} style={{minWidth:"unset",color:"#fff", cursor:"pointer"}} />

            <Modal className="pop_box" open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <MainCard 
                    title="" modal darkTitle content={false}>
                    <CardContent style={{height:"100%"}}>
                        <div className='pop_close'>
                            <Button color="primary" size="small" onClick={handleClose}>
                                {t('message.common.btn.close')}
                            </Button>
                        </div>
                        
                        <PdfViewer fileUrl={fileUrl} isLayer={true} />

                    </CardContent> 
                </MainCard>
            </Modal>
            </>
        )
    }
}

export default PdfLayer;